module.exports = __webpack_public_path__ + "3-67.jpg?58a0fa47daf6acc2cfd140da8e898cb0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-67.jpg
// module id = 149
// module chunks = 0